<template>
	<div class="header" v-bind:class="{ 'type-transparent': !headerType(), type2: headerType() }">
		<!-- <h1 class="header-logo">
			<a href="#"></a>
		</h1> -->
		<router-link type="h1" class="header-logo" to="/">
			<a href="#" class="en" v-bind:class="{ active: currentRouteName == 'pcMain' }"></a>
		</router-link>
		<ul class="header-menu" v-bind:class="{ show: mobileMenu }">
			<li type="li" class="header-menu--item" @click="goMenu('/pc/project')">
				<a href="#" v-bind:class="{ active: isOffice() }">project</a>
			</li>
			<li type="li" class="header-menu--item" @click="goMenu('/pc/interior')">
				<a href="#" v-bind:class="{ active: currentRouteName == 'pcInterior' }">interior</a>
			</li>
			<li type="li" class="header-menu--item" @click="goMenu2()">
				<a href="#">office</a>
			</li>
			<li type="li" class="header-menu--item" @click="goMenu('/pc/about')">
				<a href="#" v-bind:class="{ active: currentRouteName == 'pcAbout' }">about</a>
			</li>
			<li type="li" class="header-menu--item" @click="goMenu('/pc/contact')">
				<a href="#" v-bind:class="{ active: currentRouteName == 'pcContact' }">contact</a>
			</li>
			<li class="header-menu--item mobile">
				<button type="button" class="btn btn-close" @click="mobileMenu = false"></button>
			</li>
		</ul>
		<button type="button" class="btn btn-menu" @click="mobileMenu = true"></button>
	</div>
</template>

<script>
export default {
	name: 'HeaderComponent',
	components: {},
	computed: {
		currentRouteName() {
			return this.$route.name;
		},
		getLogin() {
			if (this.$store.getters.getToken.accessToken) {
				return true;
			} else {
				return false;
			}
		},
	},
	data() {
		return {
			mobileMenu: false,
		};
	},
	created() {
		window.resultAddress = this.resultAddress;
	},
	updated() {},
	methods: {
		btnMain() {
			this.$router.push({ name: 'MainDashboard' });
		},
		isOffice() {
			if (this.currentRouteName == 'pcProject') {
				return true;
			} else if (this.currentRouteName == 'Attere') {
				return true;
			} else if (this.currentRouteName == 'Donggwang') {
				return true;
			} else if (this.currentRouteName == 'Everhome') {
				return true;
			} else if (this.currentRouteName == 'Fnc') {
				return true;
			} else if (this.currentRouteName == 'Ilhwan') {
				return true;
			} else if (this.currentRouteName == 'Imporm') {
				return true;
			} else if (this.currentRouteName == 'Inno') {
				return true;
			} else if (this.currentRouteName == 'Pcn') {
				return true;
			} else if (this.currentRouteName == 'Samu') {
				return true;
			} else if (this.currentRouteName == 'Seongui') {
				return true;
			} else if (this.currentRouteName == 'Yeonseung') {
				return true;
			} else {
				return false;
			}
		},
		headerType() {
			if (this.currentRouteName == 'pcContact') {
				return true;
			} else if (this.currentRouteName == 'Attere') {
				return true;
			} else if (this.currentRouteName == 'Donggwang') {
				return true;
			} else if (this.currentRouteName == 'Everhome') {
				return true;
			} else if (this.currentRouteName == 'Fnc') {
				return true;
			} else if (this.currentRouteName == 'Ilhwan') {
				return true;
			} else if (this.currentRouteName == 'Imporm') {
				return true;
			} else if (this.currentRouteName == 'Inno') {
				return true;
			} else if (this.currentRouteName == 'Pcn') {
				return true;
			} else if (this.currentRouteName == 'Samu') {
				return true;
			} else if (this.currentRouteName == 'Seongui') {
				return true;
			} else if (this.currentRouteName == 'Yeonseung') {
				return true;
			} else {
				return false;
			}
		},
		goMenu(name) {
			this.mobileMenu = false;
			this.$router.push(name);
		},
		goMenu2() {
			window.location.href = process.env.VUE_APP_SERVER;
		},
	},
};
</script>
